import { returnThreeColor } from "./returnThreeColor";

export const DEFAULT_ROOM_SIZES = {
    length: 8000,
    width: 5000,
    height: 2600,
};

export function resetRoomSizes() {
    Object.assign(servObj.roomSize, DEFAULT_ROOM_SIZES);

    Object.assign(servObj.building, {
        width: DEFAULT_ROOM_SIZES.length,
        depth: DEFAULT_ROOM_SIZES.width,
        height: DEFAULT_ROOM_SIZES.height,
    });
}

export function resetRoomColors() {
    const building = servObj.building;

    building.changeWallsColor(returnThreeColor(building.DEFAULT_ROOM_COLORS.walls));
    building.changeFloorColor(returnThreeColor(building.DEFAULT_ROOM_COLORS.floor));
}
